module.exports = __webpack_public_path__ + "img/cybersecurity-img-3.df1b7b7f.jpg";